<template>
  <!-- 专业助教PA -->
  <div class="PA">
    <PublicScore :logo="Logo2" :type="'pa'" :color="'#2b257b'" />
  </div>
</template>

<script>
import PublicScore from '../component/scoreQuery.vue'
import Logo2 from '@/assets/images/logo2.png'

export default {
  name: 'PA',
  components: {
    PublicScore
  },
  data() {
    return {
      Logo2
    }
  }
}
</script>
